var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2321 5110 c-1340 -130 -2361 -1283 -2318 -2620 13 -389 97 -726 268 -1069 249 -502 647 -900 1150 -1150 815 -406 1779 -350 2539 147 297 194 579 482 771 788 74 116 184 342 234 478 51 138 110 376 131 531 23 157 26 521 6 660 -59 415 -191 769 -410 1099 -92 140 -185 254 -315 385 -399 403 -895 653 -1462 737 -122 18 -466 26 -594 14z m-708 -1215 c100 -26 178 -91 221 -184 32 -70 29 -188 -6 -263 -52 -111 -150 -177 -274 -186 -132 -9 -239 50 -303 168 -33 60 -36 71 -36 150 0 98 20 152 80 219 47 52 88 77 156 95 70 19 93 19 162 1z m1851 -865 c194 -49 313 -159 380 -351 55 -158 58 -194 63 -856 l5 -613 -280 0 -281 0 -3 548 c-4 537 -4 548 -27 615 -44 133 -119 186 -262 187 -178 0 -263 -65 -317 -243 -13 -44 -16 -136 -19 -579 l-4 -528 -275 0 -274 0 0 900 0 900 265 0 265 0 1 -122 0 -123 22 30 c103 139 230 220 392 251 89 17 249 10 349 -16z m-1646 -917 l-3 -898 -277 -3 -278 -2 0 900 0 900 280 0 280 0 -2 -897z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ce6fd0010943ab3151e0963be7e1ddd6.svg";
export { ForwardRef as ReactComponent };